var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useRegistrationForm from "../../../../../hooks/useRegistrationForm";
export var enrichRegistrationFormPropsMsd = function () {
    var _a = useRegistrationForm(), contents = _a.contents, allCountries = _a.allCountries, eventCountries = _a.eventCountries, hasInternal = _a.hasInternal, isInternalUser = _a.isInternalUser, languages = _a.languages, specialtyInputValue = _a.specialtyInputValue, departmentInputValue = _a.departmentInputValue, getTranslatedOptions = _a.getTranslatedOptions, getRegistrationFormProps = _a.getRegistrationFormProps;
    var _b = contents, error_language_required = _b.error_language_required, country_of_work = _b.country_of_work, email = _b.email, language = _b.language, internal = _b.internal, external = _b.external, firstname = _b.firstname, lastname = _b.lastname, country = _b.country, istitution = _b.istitution, specialty = _b.specialty, department = _b.department, other_department = _b.other_department, internal_true_value_label = _b.internal_true_value_label, internal_false_value_label = _b.internal_false_value_label;
    var inputs = [];
    var languageInput = {
        type: "hidden",
        name: "lang_id",
        value: languages[0].value
    };
    if (languages.length > 1) {
        languageInput = {
            type: "select",
            label: language,
            required: true,
            name: "lang_id",
            rules: [
                {
                    required: true,
                    message: error_language_required
                }
            ],
            options: languages
        };
    }
    inputs.push(languageInput);
    if (hasInternal) {
        inputs.push({
            type: "select",
            label: internal,
            required: true,
            name: "is_internal",
            rules: [
                {
                    required: true,
                    message: ""
                }
            ],
            options: [
                {
                    value: 1,
                    label: internal_true_value_label
                },
                {
                    value: 0,
                    label: internal_false_value_label
                }
            ]
        });
    }
    inputs = __spreadArray(__spreadArray([], inputs, true), [
        {
            type: "text",
            label: firstname,
            required: true,
            name: "firstname",
            rules: [
                {
                    required: true,
                    message: "Please input your firstname!"
                }
            ]
        },
        {
            type: "text",
            label: lastname,
            required: true,
            name: "lastname",
            rules: [
                {
                    required: true,
                    message: "Please input your lastname!"
                }
            ]
        }
    ], false);
    if (!isInternalUser) {
        inputs = __spreadArray(__spreadArray([], inputs, true), [
            {
                type: "select",
                label: country,
                required: true,
                name: "country_id",
                rules: [
                    {
                        required: true,
                        message: "Please select your country!"
                    }
                ],
                options: eventCountries
            },
            {
                type: "text",
                label: istitution,
                required: true,
                name: "institution",
                rules: [
                    {
                        required: true,
                        message: "Please input your institution!"
                    }
                ]
            },
            {
                type: "select",
                label: specialty,
                required: true,
                name: "specialty",
                rules: [
                    {
                        required: true,
                        message: "Please select your specialty!"
                    }
                ],
                options: getTranslatedOptions()
            }
        ], false);
        if (specialtyInputValue === "Other") {
            inputs.push({
                type: "text",
                label: specialty,
                required: true,
                name: "other_specialty",
                rules: [
                    {
                        required: true,
                        message: "Please input your other speciality"
                    }
                ]
            });
        }
    }
    else {
        inputs = __spreadArray(__spreadArray([], inputs, true), [
            {
                type: "select",
                label: country_of_work,
                required: true,
                name: "country_id_of_work",
                options: allCountries,
                rules: [
                    {
                        required: true,
                        message: "Please select your country!"
                    }
                ]
            },
            {
                type: "select",
                label: department,
                required: true,
                name: "department",
                rules: [
                    {
                        required: true,
                        message: "Please select your department!"
                    }
                ],
                options: [
                    {
                        value: "MRL/GMSA",
                        label: "MRL/GMSA"
                    },
                    {
                        value: "Other",
                        label: "Other"
                    }
                ]
            }
        ], false);
        if (departmentInputValue === "Other") {
            inputs.push({
                type: "text",
                label: other_department,
                required: true,
                name: "other_department",
                rules: [
                    {
                        required: true,
                        message: "Please input your other department!"
                    }
                ]
            });
        }
    }
    inputs.push({
        type: "email",
        label: email,
        required: true,
        name: "email",
        rules: [
            { type: "email", message: "Please insert a valid email" },
            {
                required: true,
                message: "Please input your email!"
            }
        ]
    });
    return getRegistrationFormProps({ inputs: inputs });
};
